const LS_KEY = 'bs_cookie_consent';

if (!localStorage.getItem(LS_KEY)) {
  const banner = document.createElement('div');
  banner.id = 'cookie-banner';
  banner.innerHTML = `
    <span>We use cookies strictly necessary for authentication and session management. No tracking or advertising cookies. <a href="/privacy.html" target="_blank">Privacy Policy</a></span>
    <button id="cookie-accept">Got it</button>
  `;
  banner.style.cssText = [
    'position:fixed', 'bottom:0', 'left:0', 'right:0', 'z-index:99999',
    'display:flex', 'align-items:center', 'justify-content:space-between', 'gap:16px',
    'padding:12px 20px', 'background:#111', 'border-top:1px solid #333',
    'font-size:12px', 'color:#aaa', 'font-family:inherit',
  ].join(';');

  document.addEventListener('DOMContentLoaded', () => {
    document.body.appendChild(banner);
    document.getElementById('cookie-accept').addEventListener('click', () => {
      localStorage.setItem(LS_KEY, '1');
      banner.remove();
    });
  });
}
